/** * Created by lobin on 2019/4/1. */
<template>
  <div class="introduce">
    <div class="detail-single inner home-inner protocol">
        <div class="detail-text">
        <h1 class="title">隐私政策</h1>
欢迎您使用蓉e聘-C端产品和服务蓉e聘-C端产品和服务是由成都蓉易聘网络科技有限责任公司（以下简称“我们”）（注册地址：成都市天府新区华阳华府大道一段1号2栋2单元13层8号、9号）通过包括但不限于蓉e聘-C端网站（www.itneituiquan.com）、相关微信开放平台账号或小程序以及随技术发展可能出现的其他新形态等途径向您提供的产品和服务。我们非常重视您的隐私保护和个人信息保护，特制定本《隐私政策》帮助您了解以下内容：
<br/><b>一、引言</b>
<br/>为了切实保护蓉e聘-C端用户隐私权和个人信息，优化用户体验，蓉e聘-C端根据<a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E4%BF%9D%E6%8A%A4%E6%B3%95/24220563?fr=ge_ala" target="_blank">《中华人民共和国个人信息保护法》</a>《中华人民共和国网络安全法》《常见类型移动互联网应用程序必要个人信息范围规定》等法律法规，并参考《信息安全技术 个人信息安全规范》（GB/T 35273-2020）等国家标准，制定本《隐私政策》。本《隐私政策》适用于我们向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的蓉e聘-C端服务。
<br/>本《隐私政策》将详细说明每个功能可能收集的个人信息范围、收集目的，收集方式，以及拒绝提供个人信息可能的影响。请知悉，如拒绝提供非必要个人信息或附加功能所需信息时，您仍然能够使用蓉e聘-C端基本功能。
<br/>本《隐私政策》将向您说明蓉e聘-C端可能需要调取的设备权限、调用的目的或其对应的业务功能、调用前是否询问以及用户关闭相应权限的方式，请知悉，您同意本《隐私政策》后，相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启，权限开启后，您还可以随时通过设备设置权限关闭，您不同意开启权限，将不会影响其他非相关业务功能的正常使用。
<br/>我们希望您在使用蓉e聘-C端服务前仔细阅读并理解本《隐私政策》的所有内容，希望您可以根据自己的理解做出合适的选择。此外，当我们将您的个人信息用于本《隐私政策》未涵盖的用途时，我们会事先征求您的同意。
<br/><b>二、我们如何收集和使用您的个人信息</b>
<p>(一)基本功能及相关必要个人信息</p>
在您使用蓉e聘-C端提供的以下服务或功能过程中，我们将基于以下基本功能收集您的相关必要个人信息。
<br/>1.账号注册、登录
<br/>当您注册、登录蓉e聘-C端系统时，您需要向我们提供您本人的手机号码，以便我们向您发送短信验证码来验证您的身份是否有效（手机号码是蓉e聘-C端履行国家法律法规关于网络实名制要求的必要信息，若您拒绝提供，我们可能无法为您提供信息发布、简历投递等功能，但不影响您通过游客模式或访问www.itneituiquan.com浏览、搜索职位）。
<br/>注：您的手机号码在您没有主动或同意交换的情况下，不会展示给其他用户。
<br/>【蓉e聘-C端账号注册】您在注册/登录页面通过短信验证后即注册了蓉e聘-C端账号，我们将通过蓉e聘-C端账号为您提供服务。您可使用该账号登录并使用我们提供的蓉e聘-C端平台服务，包括蓉e聘-C端求职端、蓉e聘-C端招聘端、兼职猎头端等网站及客户端。
<br/>【第三方账号快捷登录】当您使用第三方软件（例如：微信/百度/支付宝）上的蓉e聘-C端小程序时，您可以使用该等第三方软件账号快捷登录蓉e聘-C端小程序，您授权我们获取该第三方账号绑定的手机号码，用于关联您的蓉e聘-C端账号并展示您已填写的信息。若您是直接使用第三方软件的账号进行注册的情况下，为满足相关法律法规的网络实名制要求，我们需要您绑定您的手机号码，如您拒绝提供手机号码进行核验，将导致您注册失败，但不影响您使用职位浏览功能。
<br/>2.完善在线简历
<br/>对于求职者，在您注册成功后，首先您需要完善在线简历（公开），设置您的头像，填写您的姓名、性别、求职身份、参加工作时间、出生年月、个人优势、工作经历（公司名称、所在行业、在职时间、职位名称、工作内容、技能标签、工作业绩、所属部门）、项目经历（项目名称、项目角色、项目时间、项目描述、项目业绩、项目链接）、教育经历（学校、学历、专业、在校时间段、在校经历、毕业设计/论文题目及描述）、资格证书、社交主页、志愿者服务经历（项目名称、服务时长、项目时间、项目描述）、求职期望（求职类型、期望城市、期望职位、职位偏好、薪资要求、期望行业）、求职状态。我们将根据您的以上信息，为您匹配可能合适您的岗位，将您推荐给可能合适的招聘者。您的个人信息（包括真实手机号码、微信号）在您没有主动或同意交换的情况下，不会展示给其他用户。
<br/><p>(二)附加功能及相关非必要个人信息</p>
1.招聘者身份认证
<br/>招聘者包括用人单位用户和人力资源服务机构用户。对于招聘者，您使用招聘服务之前，需通过实名认证与实人认证。您需要向我们提供您本人的身份信息用于身份核验，包括真实的姓名、身份证号、人脸图像及视频（实现核验功能后即删除）；同时完善您的工作信息，包括您工作单位的名称、职位头衔，企业邮箱、工牌、在职证明，以证明您可以代表该单位进行招聘，保证招聘的真实性，维护求职者合法权益。如果您提交的单位系首次在蓉e聘-C端上发布招聘信息，那么您还需要提供营业执照以验证招聘单位的合法性。认证通过后，您发布的职位方可正常对外显示。
<br/>2.投递简历
<br/>对于求职者，在进行简历投递前，您需要先上传一份附件简历（含视频作品），蓉e聘-C端会收集您的附件简历，以便将其通过蓉e聘-C端传递至招聘者或通过邮箱发送至招聘者的企业邮箱。
<br/>3.个性化推荐服务
<br/>(1)您可以通过蓉e聘-C端软件内的推荐页，浏览到可能会满足您的需求或期望的招聘信息或求职者。我们会保留您的关键词搜索记录，避免您重复输入搜索内容。同时，我们会基于您提交的求职意向或招聘意向（如您是求职者，您填写的在线简历，例如求职期望、工作经历等，或如您是招聘者，您填写发布的职位信息），您的操作记录（如：关键词搜索记录、浏览、关注、收藏记录及开聊对象企业类型、开聊情况），您的位置信息，为您推荐、展示您可能感兴趣的或与您较为匹配的职位、求职者，有了社区相关内容或其他产品或服务。此外，我们可能基于您的操作记录和反馈为您推荐您感兴趣的商圈或行政区域，您可以根据页面提示添加该区域为您的目标求职地点。添加后，我们将优先为您该地点附近的职位。
<br/>温馨提示：蓉e聘-C端无法保证推荐算法的绝对精准，也无法确保您百分百满意蓉e聘-C端的推荐服务，无论有偿还是免费。
<br/>(2)我们还可能会根据您提供的联系方式，通过短信、电话或您同意的其他方式联系您，向您推荐您可能感兴趣的岗位或候选人及我们提供的产品或服务。如您拒绝接受短信或电话营销，您可以根据短信或电话中的指示退订我们的短信或电话营销信息（详见本政策第六部分“您的权利”-第（三）段“改变授权范围”）。
<br/>4.约面试
<br/>当您在觉得候选人简历合适的时候，并通过蓉e聘-C端提供的约面试功能成功发出面试邀请后，如对方接受了您的面试邀请，您的手机号码可能需要向对方进行展示，避免对方在前往面试地点时无法与您取得联系；
<br/>5.求职安全及服务质量保障
<br/>为了增强蓉e聘-C端的求职招聘、邀约面试等过程中的安全性，尽可能保障您或其他用户在招聘求职过程中的人身、财产安全免遭侵害，以及保障我们向您提供服务的质量，我们会收集您的以下个人信息：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(1)我们仅会基于处理您的投诉举报、申诉、出于提升安全性的考虑，使用您在商务场景下产生的面试记录，包括您的手机号码、微信，以及您的身份信息，如账号ID、手机号码、身份证号，以处理投诉举报事项和纠纷。如您为招聘者，我们可能还将使用您的面部识别信息（实现核验功能后即删除）对您进行身份核验、安全检测等。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(2)在我们检测到您的账号和行为存在异常或违规，以及您被其他用户举报时，我们可能会要求您提供您的姓名和身份证号，以验证当前用户是否为您本人。如您拒绝提供上述信息进行身份核验，您将无法正常使用我们的产品及/或服务。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(3)在您授权允许我们打开您的位置权限后，为发现、定位和排查行为异常，我们需要获取或更新您的设备标识信息、位置信息、操作行为。为了求职者的人身、财产安全，我们将在招聘者身份认证（环境认证）、地址核验、发布/修改职位、通过PC端登录、在线开聊等场景中，收集招聘者的位置信息以核验人企关系，防止作弊风险，保障招聘求职安全。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(4)为了保障软件与服务的安全运行、运营的质量及效率，我们会在您登录、使用过程中，收集您的设备信息（包括设备标识信息（IDFA、OAID、Android_id）、IP地址、MAC地址、WIFI信息（BSSID、SSID）、网络相关信息（网络接入方式、类型、状态等）、应用信息（指定应用信息、正在运行的进程信息及其他应用相关信息）、传感器信息、蓝牙信息、设备参数及系统信息（设备型号、操作系统及硬件相关信息）。在安全监测场景下，我们会调用设备的加速度传感器，用以检测设备的动/静状态，排查设备异常使用情况，确保产品和服务的运行和运营安全。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(5)为了预防恶意程序、保障运营质量及效率，我们会收集您的服务日志信息（包括您的操作使用信息，如浏览记录、点击记录、搜索查询记录、收藏记录、发布信息、分享信息，以及操作日期和时间）。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(6)为了便于定位并解决您反馈的软件问题，保障服务质量，当您通过APP页面特定入口（如帮助反馈-反馈与建议）或在线客服向我们反馈问题时，我们会收集您的服务日志信息以及您在商务场景下产生的其他数据（如通讯信息）。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(7)为了验证您的身份信息，防止他人未经授权访问您的账号，我们会在您授权同意后，访问您的设备信息、微信OpenID。如您为招聘者，我们可能还将核验您的面部识别信息（实现核验功能后即删除）；在触发邮箱安全验证的场景下，我们会向您的邮箱发送验证码，如您未填写企业邮箱地址，则需要您先完成绑定。若您不同意进行上述相应的身份验证，我们可能无法利用身份信息验证的方式保障您的账号安全。
<br/><p>(三)转让</p>
我们不会将您的个人信息转让给除本公司关联公司外的任何公司、组织和个人，但以下情形除外：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.事先获得您的明确授权或同意；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
<br/><p>(四)公开披露</p>
我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示我们的产品或服务的整体使用趋势。请您放心，这些统计信息不包含您的任何身份识别信息。我们仅会在以下情形下，公开披露您的个人信息：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.获得您的明确同意；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。
<br/><p>(五)例外情形</p>
在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.与我们履行法律法规规定的义务相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.与国家安全、国防安全直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.与公共安全、公共卫生、重大公共利益直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.与刑事侦查、起诉、审判和判决执行等直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.您自行向社会公众公开的个人信息；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.根据个人信息主体要求签订和履行合同所必需的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.法律法规规定的其他情形。
<br/><b>五、我们如何保存及保护您的个人信息</b>
<br/><p>(一)保存信息</p>1.信息存储
<br/>您在使用蓉e聘-C端产品及服务期间，我们将持续为您保存您的个人信息。如果您注销账号或主动删除上述信息，我们会及时删除您的个人信息或进行匿名化处理，因法律规定需要留存个人信息的，我们不会再将其用于日常业务活动中。
<br/>2.保存地域
<br/>我们承诺，您的个人信息将只存储在位于中华人民共和国境内的服务器上，您的信息不会被我们主动传输到境外。如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况，并依法开展安全评估。
<br/>3.例外情况
<br/>一般而言，我们仅为实现目的所必需的合理时间保留您的个人信息，超出保留时间后，我们会根据适用法律的要求及时删除您的个人信息或进行匿名化处理。下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）为遵守法律法规等有关规定的适用；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）为遵守法院判决、裁定或其他法律程序的规定；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）为遵守相关政府机关或法定授权组织的要求；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）为保护我们及我们的客户、用户或雇员的人身财产安全；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）其他合法权益所合理必需的用途。
<br/>4.当我们的产品或服务发生停止运营的情形时，我们将按照法律规定向用户进行通知，通知方式包括但不限于消息推送、公告等，并在合理期限内删除或匿名化处理您的个人信息。
<br/><p>(二)保护措施</p>
1.我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对蓉e聘-C端网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全培训课程，加强员工对于保护个人信息重要性的认识。
<br/>2.我们从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过网络安全等级保护的测评。
<br/>3.我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本《隐私政策》所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求或双方另有约定）。
<br/>4.互联网并非绝对安全的环境，使用蓉e聘-C端服务时，我们强烈建议您不要使用非蓉e聘-C端推荐的通信方式发送您的信息。您可以通过我们的服务与他人建立联系和相互分享内容。当您通过我们的服务进行沟通交流、分享内容时，您可以自主选择沟通、分享的对象，作为能够看到您的联络方式、交流信息等相关信息的第三方。
<br/>5.在使用蓉e聘-C端服务进行沟通时，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账号发生泄露，请您立即通过本《隐私政策》的“十、如何联系我们”中公布的联系方式与我们联系，以便我们根据您的申请采取相应措施。
<br/>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评论、沟通时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。请妥善保管账号，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。
<br/><p>(三)安全事件通知</p>
1.我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。
<br/>2.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时通过软件内部提醒、邮件、短信或电话等方式向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况通过上述方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
<br/><b>六、您的权利</b>
<br/>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
<br/><p>(一)访问和修改您的个人信息</p>
1.访问修改姓名
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）求职者可通过我的>在线简历>姓名修改您的姓名；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）已在蓉e聘-C端招聘端端完成实名认证的招聘者，无法直接修改姓名，可选择对外展示为“X先生/女士”。如需修改，可先解绑蓉e聘-C端招聘端实名认证，再以新的姓名重新进行实名认证。
<br/><p>温馨提示：解绑实名认证后，您将无法使用招聘功能。如需继续使用招聘功能，请切换到蓉e聘-C端招聘端，按提示重新完成实名认证。</p>
2.访问和修改性别
<br/>求职者可以通过我的>在线简历>性别更改性别；
<br/>已经完成实名认证的招聘者，不能修改性别。
<br/>3.访问和修改简历内容
<br/>求职者可以在我的>在线简历中修改简历内容；
<br/>求职者可以在我的>设置>隐私保护中修改简历隐藏或展示；
<br/>求职者可以在我的>附件简历增加新的附件简历文件或删除已有的附件简历文件。
<br/>4.访问和修改手机号码
<br/>用户可以在我的>设置>账号与安全中心>账号管理>修改手机号中更换手机号码。
<br/>5.访问和修改微信号
<br/>招聘者可以在我的>点击头像>微信号中修改；
<br/>求职者可以在我的>在线简历>点击姓名>微信号中添加或修改；
<br/>用户可以在我的>设置>账号与安全中心>账号管理>微信绑定>解除绑定中解除微信绑定。
<br/>6.访问和修改邮箱
<br/>求职者可以在我的>在线简历>点击姓名>邮箱中添加或修改；
<br/>招聘者可以在我的>姓名>接收简历邮箱中添加或修改。
<br/>7.访问和修改头像
<br/>求职者可以在我的>在线简历>点击姓名>头像中查看和修改；
<br/>招聘者可以在我的>姓名>头像中查看和修改。
<br/>8.如果您无法通过上述链接访问该等个人信息，您可以通过本《隐私政策》公布的联系方式与我们联系。
<br/>9.您在使用我们的产品和服务过程中产生的其他个人信息，对于您的合理请求，我们会相应向您提供。如果您想访问您在使用我们的产品和服务过程中产生的其他个人信息，请通过本《隐私政策》的“十、如何联系我们”中公布的联系方式与我们联系。
<br/>10.您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以通过上述段落中列明的方式提出更正或补充申请。为保障安全，我们将在您行使更正权前对您的身份进行验证。
<br/><p>(二)删除您的个人信息</p>
您可以通过“1.访问和修改您的个人信息”中列明的方式删除您的部分信息。
<br/>您可以在搜索>历史搜索中点击删除按钮清除搜索记录，在您主动清除后，我们不会再保留您的搜索记录。
<br/>在以下情形，您可以通过本《隐私政策》公布的联系方式与我们联系，向我们提出删除您的个人信息的请求：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.如果我们违反法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.我们没有征求您的明确同意，收集了您的个人信息。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.已实现个人信息处理目的、无法实现或者实现处理目的不再必要。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.您注销了账号。
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.我们停止对您提供服务。
<br/>此外，法律法规另有规定，或达到与您约定或者个人信息处理规则明确的存储期限，或您撤回同意、注销账号等情形下，我们会遵照删除制度，采取措施对您的信息进行删除。
<br/><p>(三)改变授权范围</p>
1.改变或撤回敏感信息权限
<br/>您可以在设备本身操作系统中关闭地理位置、摄像头、麦克风等权限，或通过我的>设置>账号与安全中心>权限管理改变同意范围或撤回您的授权。
<br/>2.拒绝接受推送及营销信息
<br/>您可以在电话中明确表示拒绝或通过手机设置关闭“推送通知”以及短信回复“TD”的方式拒绝接收广告信息，您知悉，短信退订可能会收取一定的通信费，该费用由您自行向运营商支付。
<br/>3.隐藏求职偏好
<br/>求职者可以在我的>设置>隐私保护>对企业HR隐藏求职偏好中，修改求职偏好的隐藏或展示状态。求职者对招聘者隐藏求职偏好后，招聘者将无法查看求职者的求职偏好信息。
<br/>温馨提示：隐藏求职偏好信息可能会影响求职者的求职效率，但不会影响其他功能的使用。
<br/><p>(四)注销您的账号</p>
您可以通过用户协议中预留的电话，联系我们，我们将为你进入人工注销流程。
<br/><p>(五)提前获知产品和服务停止运营</p>
蓉e聘-C端愿一直陪伴您，若因特殊原因导致蓉e聘-C端被迫停止运营，我们将按照法律法规的要求，在产品和/或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。
<br/><p>(六)您的其他权利</p>
在法律允许的情况下，您可以通过【我的->个人信息】复制您的个人信息，并请求将您的个人信息转移至指定的个人信息处理者，您还可以要求我们解释对您的个人信息处理规则。您可以通过本政策公布的联系方式与我们联系行使上述权利。
<br/><p>(七)响应您的上述请求</p>
1.为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求，我们会在收到您的请求并验证您的用户身份后的15个工作日内响应您的上述请求。
<br/>2.对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
<br/><p>(八)响应请求的例外</p>
在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.与我们履行法律法规规定的义务相关的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.与国家安全、国防安全直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.与公共安全、公共卫生、重大公共利益直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.与刑事侦查、起诉、审判和执行判决等直接相关的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.证据表明您可能存在明显恶意、滥用权利及占用资源、辱骂客服人员等相关情形的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.您的请求超出了一般技术手段和商业成本可覆盖的范围；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.涉及商业秘密的。
<br/><b>七、我们如何处理未成年人的个人信息</b>
<br/>蓉e聘-C端非常重视对未成年人信息的保护。基于我们的产品、网站和服务的性质，我们不会故意从16岁以下的人士收集或维护我们产品和服务上的个人信息，并且我们产品和服务的任何部分都不会针对16岁以下的人士。如果您未满16岁，请不要以任何方式使用或访问我们的产品和服务。当我们得知我们无意中收集了16岁以下的人士的个人信息时，我们会根据适用法律法规进行删除或采取其他合适的措施。
<br/><b>八、我们对去世用户的个人信息保护</b>
<br/>蓉e聘-C端将从2021年11月1日起，根据《中华人民共和国个人信息保护法》的相关规定加强对死者个人信息的保护。蓉e聘-C端用户（仅限自然人）去世后，其近亲属为了自身的合法、正当利益，可以通过本政策第十条公布的联系方式与我们联系，对去世用户的相关个人信息行使查阅、复制、更正、删除等权利，但是去世用户生前另有安排的除外。
<br/><b>九、本《隐私政策》的更新</b>
<br/>我们可能适时修订本《隐私政策》内容。如该等变更会导致您在本《隐私政策》项下权利的实质变化，我们将在变更生效前，通过系统推送、电子邮件、短信或页面公告等方式通知您。
<br/><p>若您不同意该等变更应停止使用蓉e聘-C端产品和服务，或通过本《隐私政策》公布的联系方式要求暂时封停您的账号。若您继续使用我们的产品或服务，即表示您同意受修订后的本《隐私政策》的约束。</p>
本《隐私政策》所指的实质变化包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.个人信息共享、转让或公开披露的主要对象发生变化；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.您参与个人信息处理方面的权利及其行使方式发生重大变化；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.其他可能对您的个人信息权益产生重大影响的变化时；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.个人信息出境情况发生变更时。
<br/><b>十、如何联系我们</b>
<br/>如果您对本《隐私政策》及我们对您的个人信息的处理有任何疑问、意见、建议，或您发现可能存在个人信息被泄露的情形，请通过以下方式与我们联系：
<br/>1.我们设立了个人信息保护专职部门，您可以通过其邮箱：itneituiquan@itneituiquan.com与我们联系。
<br/>一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、工信、公安、人力资源、市场监督管理等部门进行投诉或举报。
<br/><b>十一、适用法律</b>
<br/>本《隐私政策》与《蓉e聘-C端用户协议》共同构成您使用蓉e聘-C端服务的基本协议文件。本《隐私政策》适用中华人民共和国现行法律法规。
</div>

    </div>
  </div>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.introduce {
  padding-top: 20px;
  line-height: 26px;
  color: #414a60;
  font-size: 14px;
  //margin-bottom: 40px;
  //text-indent: 2em; /* 2个字符的宽度 */
  .protocol {
    background: #fff;
    margin: 37px auto 55px auto;
    padding: 15px 45px 65px 45px;
    min-height: calc(100% - 330px);
    box-sizing: border-box;
  }
  .home-inner {
    max-width: 1200px;
  }
  .inner {
    max-width: 1200px;
    margin: 0 auto;
  }
}
.protocol h1 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 25px;
  font-size: 20px;
}
b{
    font-size: 16px;
}
p{
    padding: 0 !important;
    margin: 0 !important;
    font-weight: 600;
}
</style>
